export default "__VITE_ASSET__j3ymlliK__"